<template>
<div id="app">
    <div id="app">
        <router-view />
    </div>
</div>
</template>

<script>
import Firebase from './lib/Firebase'
export default {
    name: 'app',

    /* created() {
        var uid = Firebase.auth().currentUser.uid;
        var userStatusDatabaseRef = Firebase.database().ref('/users/' + uid);

        var isOfflineForDatabase = {
            state: 'offline',
            last_changed: new Date(),
        };

        var isOnlineForDatabase = {
            state: 'online',
            last_changed: new Date(),
        };

        // [END_EXCLUDE]
        var userStatusFirestoreRef = Firebase.firestore().doc('/users/' + uid);

        // Firestore uses a different server timestamp value, so we'll 
        // create two more constants for Firestore state.
        var isOfflineForFirestore = {
            state: 'offline',
            last_changed: new Date(),
        };

        var isOnlineForFirestore = {
            state: 'online',
            last_changed: new Date(),
        };

        Firebase.database().ref('.info/connected').on('value', function (snapshot) {
            if (snapshot.val() == false) {
                // Instead of simply returning, we'll also set Firestore's state
                // to 'offline'. This ensures that our Firestore cache is aware
                // of the switch to 'offline.'
                userStatusFirestoreRef.update(isOfflineForFirestore);
                return;
            };

            userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function () {
                userStatusDatabaseRef.set(isOnlineForDatabase);

                // We'll also add Firestore set here for when we come online.
                userStatusFirestoreRef.upadte(isOnlineForFirestore);
            });
        });
    }, */
}
</script>

<style lang="scss">
.button {
 // width: 100%;
background: #a52530;
/* background-size: 400% 400%; */
//border: 0px !important;
border-radius: 0px !important;

}
.input{
    border: 0ch;
}

.box:hover{
    -webkit-box-shadow: 5px 5px 20px -4px rgba(0,102,255,0.30) !important;
-moz-box-shadow: 10px 10px 20px -4px rgba(0,102,255,0.30) !important;
box-shadow: 5px 5px 20px -4px rgba(0,102,255,0.30) !important;
}

.input{
   
    border-radius: 0px !important;
}
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #a52530;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
#app {
    background-color: #ffffff !important;
    height: 100%;

    /*  font-family: 'Nunito', sans-serif; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue